export function fixedHeader() {
  const header = document.querySelectorAll('.js-header')[0];

  if (!header) {
    return;
  }

  const observer = new IntersectionObserver(([entry]) => toggleStickyState(entry), { threshold: 1, rootMargin: "-0.1px 0px 0px 0px" });
  observer.observe(header);

  function toggleStickyState(entry) {
    if (entry.intersectionRatio < 1) {
      header.classList.add('m-sticky');
    } else {
      header.classList.remove('m-sticky');
    }
  }
}


